// extracted by mini-css-extract-plugin
export default {"header":"text-page_header__VU2Z4","isOnTop":"text-page_isOnTop__ItJXO","description":"text-page_description__SrT9j","content":"text-page_content__s+url"};